import { TagContainer } from '../models/container';
import { getEvents } from '../models/helpers';
import { NavigationEnd } from '@app/store';

const events = getEvents((action: NavigationEnd) => [
  {
    type: 'containerCall',
    container: TagContainer.Analytics,
    timeout: 1000,
    payload: { pageUrl: action.payload.url.replace(/\.$/, '') }
  }
]);

export default events;
